import { Status } from '../../../../shared/enums/status.enum';
import { UtilHelper } from '../../../../shared/helpers/utils.helper';
import { Photo } from '../../../../shared/models/photo.model';
import { Translation } from '../../../../shared/models/translation.model';
import { ProductRegisterType } from '../enum/product-register-type.enum';
import { StepStatus } from '../enum/step-status.enum';
import { Complement } from './complement.model';

export class Product {

	id: number;
	categoryId: number;
	name: string;
	type: ProductRegisterType;
	stepStatus: StepStatus;
	price: number = 0.0;
	mainPrice: number = 0.0;
	originalPrice: number;
	description: string;
	servesPeople: number;
	photoBase64: string;
	photoUrl: string;
	complements: Array<Complement>;
	photo: Photo;
	costFrom: boolean;
	order: number;
	status: Status;
	averageRating: number;
	numberReviews: number;
	alcoholic: boolean = false;
	msgError: string;
	delivery: boolean = true;
	localOrder: boolean = true;
	takeaway: boolean = true;
	availabilityControl: boolean;
	quota: number;
	externalId: string;

	// Aux view
	nameTranslations: Translation;
	descriptionTranslations: Translation;

	constructor(obj: any = { }) {
		Object.assign(this, obj);

		//Product type
		if (this.type != null && this.type['code'] == null) {
			this.type = UtilHelper.getEnumByCod(this.type, ProductRegisterType);
		}

		//Status
		if (this.status != null && this.status['code'] == null) {
			this.status = UtilHelper.getEnumByCod(this.status, Status);
		} else if (this.status == null || this.status['code'] == null) {
			this.status = Status.DRAFT;
		}
	}

	toJson(): any {
		const data: any = {
			productId: this.id || null,
			categoryId: this.categoryId,
			name: this.name,
			type: this.type['code'],
			price: this.price || 0,
			originalPrice: this.originalPrice || 0,
			stepStatus: this.stepStatus,
			description: this.description,
			servesPeople: this.servesPeople ? Number(this.servesPeople) : null,
			photoBase64: this.photoBase64 && this.photoBase64.length > 0 ? this.photoBase64.split(',')[1] : null,
			photoUrl: this.photoUrl,
			status: this.status['code'],
			order: this.order,
			alcoholic: this.alcoholic,
			delivery: this.delivery,
			takeaway: this.takeaway,
			localOrder: this.localOrder,
			availabilityControl: this.availabilityControl || false,
			quota: this.quota ? Number(this.quota) : 0,
			externalId: this.externalId
		};

		return data;
	}

	toReorderJson(): any {
		const data: any = {
			id: this.id || null,
			categoryId: this.categoryId,
			name: this.name,
			type: this.type['code'],
			price: this.price,
			stepStatus: this.stepStatus,
			description: this.description,
			servesPeople: this.servesPeople ? Number(this.servesPeople) : null,
			status: this.status['code'],
			order: this.order,
			alcoholic: this.alcoholic,
			delivery: this.delivery,
			takeaway: this.takeaway,
			localOrder: this.localOrder,
			availabilityControl: this.availabilityControl || false,
			quota: this.quota ? Number(this.quota) : 0,
			externalId: this.externalId
		};
		return data;
	}
}



// WEBPACK FOOTER //
// ./src/app/pages/category/products/models/product.model.ts